import { carouselData } from '@/mocks/home';

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12 max-w-xl mx-auto">
          精选系列策划与编辑特别推荐，深度探索影视世界的每个角落
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden cursor-pointer hover:border-primary-200/60 transition-colors group flex flex-col"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-white text-xs rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1 line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}